import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { useIntl } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import Link from 'components/Link';
import App from 'modules/App';
import CloudDrive from 'modules/CloudDrive';
import Hcp, { SearchPatients, SearchPatientsList } from 'modules/Hcp';
import { ExportDataMenu } from 'modules/HcpExports';
import { DownloadDataFromMeterBtn } from 'modules/Meter';
import Visit from 'modules/Visit';
import * as constants from '../../../constants';
import TopBar from '../../../partials/TopBar';
import ActivePatientOptions from '../TopBar/ActivePatientOptions';
import ActiveClinicMembershipBtn from '../TopBar/ActiveClinicMembershipBtn';
import EnrollCodeBtn from '../TopBar/EnrollCodeBtn';
import ProfileMenu from '../TopBar/ProfileMenu';
import Notifications from '../TopBar/Notifications';
import styles from '../TopBar/TopBar.pcss';
const DownloadMeter = ()=>{
    const isEnrollPatientInProgress = useSelector(Hcp.selectors.isEnrollPatientInProgress);
    const isMergePatientInProgress = useSelector(Hcp.selectors.isMergePatientInProgress);
    const isStartPatientVisitInProgress = useSelector(Hcp.selectors.isStartPatientVisitInProgress);
    const isEndPatientVisitInProgress = useSelector(Hcp.selectors.isEndPatientVisitInProgress);
    const isSyncInProgress = useSelector(Hcp.selectors.isSyncInProgress);
    const isFetchPhiSetInProgress = useSelector(CloudDrive.selectors.isFetchPhiSetInProgress);
    const isFetchReadingsInProgress = useSelector(CloudDrive.selectors.isFetchReadingsInProgress);
    const isDisabled = isEnrollPatientInProgress || isMergePatientInProgress || isFetchPhiSetInProgress || isFetchReadingsInProgress || isStartPatientVisitInProgress || isEndPatientVisitInProgress || isSyncInProgress;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.element,
        children: /*#__PURE__*/ _jsx(DownloadDataFromMeterBtn, {
            className: "btn--block btn--filled",
            isDisabled: isDisabled
        })
    });
};
const PatientListOptions = ()=>{
    const route = useSelector(App.selectors.route);
    if (!route || route.name !== 'patients-list') {
        return null;
    }
    return /*#__PURE__*/ _jsx(ExportDataMenu, {});
};
const preventBlur = (evt)=>{
    evt.preventDefault();
};
const blurSearch = ()=>{
    const { activeElement } = document;
    if (activeElement instanceof HTMLElement) {
        activeElement.blur();
    }
};
const HcpTopBar = ()=>{
    const intl = useIntl();
    const activeVisit = useSelector(Visit.selectors.activeVisit);
    const isDisabled = !!activeVisit;
    const tooltipText = activeVisit ? intl.formatMessage(App.messages.infos.menuDisabledIfActiveVisit) : '';
    useStyles(styles);
    return /*#__PURE__*/ _jsxs(TopBar, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.element, {
                            [styles['element--isDisabled']]: isDisabled
                        }),
                        "data-for": "globalTooltip",
                        "data-tip": tooltipText,
                        children: /*#__PURE__*/ _jsx(Link, {
                            to: activeVisit ? '' : '/',
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "/assets/img/gco-logo.png",
                                className: styles.logo,
                                alt: "GlucoContro.online"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.element, {
                            [styles['element--isDisabled']]: isDisabled
                        }),
                        "data-for": "globalTooltip",
                        "data-tip": tooltipText,
                        children: /*#__PURE__*/ _jsx(ActiveClinicMembershipBtn, {})
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.element,
                        children: /*#__PURE__*/ _jsx(EnrollCodeBtn, {})
                    }),
                    /*#__PURE__*/ _jsx(DownloadMeter, {})
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.element, styles.search, 'd-flex align-items-center', {
                    [styles['element--isDisabled']]: isDisabled
                }),
                "data-for": "globalTooltip",
                "data-tip": tooltipText,
                children: [
                    /*#__PURE__*/ _jsx(SearchPatients, {
                        forId: "topBar",
                        formName: constants.TOPBAR_SEARCH_FORM,
                        clearOnBlur: true
                    }),
                    /*#__PURE__*/ _jsx(SearchPatientsList, {
                        id: "topBar",
                        className: styles.searchModal,
                        onPatientClick: blurSearch,
                        onMouseDown: preventBlur
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.element, 'd-flex align-items-center'),
                children: [
                    /*#__PURE__*/ _jsx(ActivePatientOptions, {}),
                    /*#__PURE__*/ _jsx(PatientListOptions, {}),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.separate)
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn({
                            [styles['element--isDisabled']]: isDisabled
                        }),
                        "data-for": "globalTooltip",
                        "data-tip": tooltipText,
                        children: /*#__PURE__*/ _jsx(Notifications, {})
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn({
                            [styles['element--isDisabled']]: isDisabled
                        }),
                        "data-for": "globalTooltip",
                        "data-tip": tooltipText,
                        children: /*#__PURE__*/ _jsx(ProfileMenu, {})
                    })
                ]
            })
        ]
    });
};
export default HcpTopBar;
